import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { RecognitionComponent } from './recognition/recognition.component';
import { TeamComponent } from './team/team.component';
import { JourneyComponent } from './journey/journey.component';
import { CorporateGivingComponent } from './corporate-giving/corporate-giving.component';
// import { ProfileComponent } from './profile/profile.component';
// import { PortfolioComponent } from './portfolio/portfolio.component'; 
import { MatCardModule } from '@angular/material/card';
import { PortfolioGuard } from '../guards/portfolio.guard'; 
import { ProfileComponent } from './profile/profile.component';
import { NotFoundComponent } from '../shared/not-found/not-found.component';
import { CapabilityStatementComponent } from './capability-statement/capability-statement.component';
const routes: Routes = [
  {path:'corporate-giving', component:  CorporateGivingComponent},
  {path:'journey', component:  JourneyComponent},
  // { path: 'teams', component: TeamComponent},
  { path: 'profile/:empId', component: ProfileComponent, canActivate: [PortfolioGuard] },
  { path: 'profile/:empId/:link',component: ProfileComponent,canActivate: [PortfolioGuard]},
    {path:'recognition', component:  RecognitionComponent},
    {path:'capability-statement',component:CapabilityStatementComponent},
    { path: '404', component: NotFoundComponent }
  ];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,RouterModule.forChild(routes)
  ],
  exports: [RouterModule]

})
export class AboutRoutingModule { }
